module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/monitoringZivotnihoProstredi@3x-f47928ab75890bc3b914d79e44409af0.png";